<template>
  <div class="medical">
    <div class="medical__name">
      <img src="@/assets/img/medical.svg" alt="">
      <span>Medical Clearance Form</span>
      <img v-if="medical" src="@/assets/img/approved-icon.svg" alt="Approve">
      <img v-else src="@/assets/img/clock-snacks.svg" alt="Clock">
      <a v-if="is_sales_general_manager" :href="`${family_url}${client_hash}/medical`" target="_blank" class="medical__link"></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Medical',
  props: {
    medical: {
      type: Object,
    },
    client_hash: { String }
  },
  data() {
    return {
      family_url: process.env.VUE_APP_FAMILY
    }
  },
  computed: {
    is_sales_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager') || this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    }
  },
}
</script>

<style lang="sass" scoped>
.medical
  display: flex
  align-items: center
  gap: 30px
  padding: 9px 12px
  border: 1px solid #eaeaea
  border-radius: 10px
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
  background-color: #fff

.medical__name
  flex-shrink: 0
  display: flex
  align-items: center
  gap: 10px
  line-height: 0

  span
    color: #181818
    font-weight: 500

.medical__info
  color: #959595
  font-size: 13px

.medical__status
  color: #181818

.medical__status--red
  color: $color-error

.medical__controls
  flex-shrink: 0
  display: flex
  align-items: center
  gap: 10px

  button
    border-radius: 9px
    box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.15)
    line-height: 0
    transition: transform 0.3s

    &:hover
      transform: translateY(-1px)

.medical__link
  width: 25px
  height: 25px
  border-radius: 9px
  box-shadow: 1px 3px 8px rgba(0, 0, 0, 0.15)
  background-image: url("~@/assets/img/snacks-link.svg")
  transition: opacity 0.3s

  &:hover
    opacity: 0.8
</style>
